
import {Component, Vue} from 'vue-property-decorator';
import {homePageList} from "@/js/checkType";
import statisticApi from "@/api/statistic";
import ListV2 from "@/views/measuring/ListV2.vue";
import PublicListV2 from "@/views/standard/PublicListV2.vue";
import CertListV2 from "@/views/authorizeCert/ListV2.vue";
import InstrumentList from "@/views/instrument/List.vue";
import MechanismList from "@/views/mechanism/List.vue";

@Component({
  name: "HomePage",
  components: {MechanismList, InstrumentList, CertListV2, PublicListV2, ListV2}
})
export default class Home extends Vue {
  moduleId = 0;
  // 展示徽章主页
  showBadgeIdArr = [29, 42, 52, 27];
  badgeList = JSON.parse(JSON.stringify(homePageList));
  showDialog = false;
  dialogType = ''; // 当前应该打开的组件
  dialogTypeTitle = ''; // 当前应该打开的组件名称
  userData = this.$store.state.AuthedUser;
  showBadgeList = false;
  created() {
    if(this.$route.meta && this.$route.meta.moduleId){
      this.moduleId = this.$route.meta.moduleId;
    }
    this.haveRight();
    if (this.showBadgeIdArr.indexOf(this.moduleId) !== -1 && this.showBadgeList) {
      this.getBadgeData();
    }
  }

  haveRight(){
    const right = this.$store.state.userRights;
    right.forEach((e:any)=>{
      if(e.name == "statistical_homepage"){
        this.showBadgeList = true;
      }
    })
  }

  getBadgeData() {
    const organizationRegion = this.userData.organizationRegion;
    let region = '';
    if (organizationRegion) {
      const arr = organizationRegion.split(',');
      if (this.userData.level === '0001') {
        region = arr[0];
      } else if (this.userData.level === '0002') {
        region = arr[1];
      } else {
        region = arr[2];
      }
    }
    statisticApi.listStatisticalData(region).then((r: any) => {
      if (r.data.result === 0) {
        const rData = r.data.data;
        rData.instrumentVerificationRate = (rData.calibratedMeasuringInstrument / rData.equipmentInUse * 100).toFixed(2);
        for (const b of this.badgeList) {
          if (rData[b.key]) {
            b.count = rData[b.key];
          }
        }
      }
    });
  }

  changeActivityName(type: any) {
    if (type.key === 'instrumentVerificationRate') {
      this.$message.error("强检工作计量器具检定率暂无可展示数据");
      return false;
    }
    this.dialogType = type.key;
    this.dialogTypeTitle = type.name;
    this.showDialog = true;
  }

  closeDialog() {
    this.showDialog = false;
  }
}
